export const ALLOW_TO_SHOW_ALL_ITEMS_MAX_AMOUNT = 14;
export const LIMITED_ITEMS_BASE_AMOUNT = 10;
